"use client";

import { Card, Title, Button, Text } from "@tremor/react";
import { useEffect, useMemo, useState, useCallback } from "react";
import Link from "next/link";
import { getCookie, setCookie } from "cookies-next";

import getLanguage from "@/app/utils/getlanguage";
import { useLocale } from "@/app/context/use-locale";
import translation from "./locale/index.json";

const CookieKey = "p4u-cookies";
const normalizePath = (path: string) => {
  if (!path) return "/";
  return path.startsWith("/") ? path : `/${path}`;
};

export default function CookiesWidget() {
  const locale = useLocale();
  const content = useMemo(() => getLanguage(translation, locale), [locale]);
  const [cook, setCook] = useState(false);

  const localizedHref = useCallback(
    (path: string) => {
      const normalized = normalizePath(path);
      if (normalized === "/" || normalized === `/${locale}`) return `/${locale}`;
      return `/${locale}${normalized}`;
    },
    [locale],
  );

  useEffect(() => {
    const cookies = getCookie(CookieKey) || null;
    if (cookies) setCook(true);
  }, []);

  const setCookies = () => {
    const expirationDate = new Date();
    expirationDate.setFullYear(expirationDate.getFullYear() + 1)
    setCookie(CookieKey, true, { expires: expirationDate });
    setCook(true);
  };

  return (
    <>
      {!cook ? (
        <div className="fixed bottom-0 right-0 p-4 min-w-[5%] md:max-w-[30%]">
          <Card>
            <Title className="mb-5">{content?.title ?? ""}</Title>
            <Text>{content?.text ?? ""}</Text>
            <Link href={localizedHref("/privacy-policy")}>{content?.moreText ?? ""}</Link>
            <Button onClick={setCookies} className="min-w-full mt-2">
              {content?.btn ?? ""}
            </Button>
          </Card>
        </div>
      ) : (
        ""
      )}
    </>
  );
}
